class Slider{
    constructor($el,params = null){

        const refThis = this;

        var _defaultParams = {
            autoplay : false
        }

        this.$el = $el;
        // Si il y a des paramètres en plus, on vient fusionner ll'objets par defaut avec le nouveau.
        this.params = $.extend(_defaultParams,params);
        // this.prev = $('.slider-navigation a:first-child',this.$el);
        // this.next = $('.slider-navigation a:last-child',this.$el);
        this.visuel = $('.slider-img');
        this.text = $('.slider-text');
        this.navSlider = $('.slider-dot');
        this.current = 0;
        this.length = this.visuel.length;
        this.vw;
        this.interval = 0;
        this.stopInterval = false;
        this._isUpdating = true;
        this._isActive = false;

        // On init les clicks
        this.initNavigation();
        $(window).resize(()=>{refThis._resize();});
        this._resize();

        if(this.params.autoplay == true){
            this.update();
        }

    }
    initNavigation(){
        const refThis = this;
        // this.next.click(function(){refThis.nextSlide(); return false;});
        // this.prev.click(function(){refThis.prevSlide(); return false;});
        this.navSlider.click(function(){refThis.changeSlide($(this)); return false;})
        TweenLite.to($('.slider-dot:first-of-type rect'),5,{strokeDashoffset:200},0.5);
        $(document).keydown(function(e){
            switch (e.which){
            case 37:    //left arrow key
                refThis.prevSlide();
                break;
            case 39:    //right arrow key
                refThis.nextSlide();
                break;
            }
        });
    }

    /**
    *  Appel de la slide suivante.
    **/
    nextSlide(){
        if(!this._isActive){
            this.current++;
            if(this.current >= this.length){
                this.current = 0;
            }
            this.animateSlider();

            this._isUpdating = true;

            if(this.params.autoplay == true){
                this.update();
            }

            // si on click, on kill l'autoplay
            clearInterval(this.interval);
            this.stopInterval = true;
        }

        return false;
    }

    /**
    *  Appel de la slide précédente.
    **/
    prevSlide(){
        if(!this._isActive){
            this.current--;
            if(this.current <= -1){
                this.current = this.length-1;
            }
            this.animateSlider();

            this._isUpdating = true;

            if(this.params.autoplay == true){
                this.update();
            }

            // si on click, on kill l'autoplay
            clearInterval(this.interval);
            this.stopInterval = true;
        }

        return false;

    }

    /**
    *  Resize du slider
    **/
    _resize(){
        // Taille du slider
        this.vw = this.$el.innerWidth();
        //La taille des slides = taille du slider
        this.visuel.width(this.vw);


    }

    /**
    *  Animation du slider
    **/
    animateSlider(){

        if(!this._isActive){

            this._isActive = true;

            let $prevVisuel = this.visuel.not(`:eq(${this.current})`),
                $prevTxt = this.text.not(`:eq(${this.current})`),
                $nextVisuel = this.visuel.eq(this.current),
                $nextTxt = this.text.eq(this.current),
                ww = $(window).width(),
                refThis = this
            ;

            // let $prevDot = $('.slider-dot').not(`:eq(${this.current})`).find('rect'),
            // $nextDot = $('.slider-dot').eq(this.current).find('rect')
            // ;

            // TweenLite.fromTo($nextDot,5,{strokeDashoffset:0},{strokeDashoffset:200});
            return this.animateTimeline = new TimelineLite({
                onComplete:()=>{
                    this._isActive = false;
                }
            })

            .add(this.hideContent($prevTxt),.5)
            .to($prevVisuel,0.5,{autoAlpha:0,display:'none'},.5)
            .to($nextVisuel,0.5,{autoAlpha:1,display:'block',onStart:()=>{
                this.showDot();
            }},.5)
            // .set(this.count,{className:'-=isActive'},'-=.5')
            .add(this.showContent($nextTxt))

        }


    }

    update(){
        var refThis = this;
        if(this._isUpdating){

            // this.showDot();
            clearInterval(this.interval);
            this.interval = setInterval(function(){
                refThis.current++;
                if(refThis.current == refThis.length){
                    refThis.current = 0;
                }
                refThis.animateSlider();
            }, 5000);
        }
    }

    showContent(el){
        let refThis,
        $surtitle = $('.s-cap2',el),
        $title = $('h2',el),
        $lieu = $('.lieu', el),
        $button = $('.button',el)
        ;

        let tl = new TimelineLite()
        .to(el,.3,{autoAlpha:1,display:'block',ease:Power4.easeOut})
        .fromTo($surtitle,.3,{y:30,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut},0)
        .fromTo($title,.3,{y:30,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut},.05)
        .fromTo($lieu,.3,{y:30,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut},.1)
        .fromTo($button,.3,{y:30,alpha:0},{y:0,alpha:1,force3D:true,ease:Power4.easeOut},.15)

        return tl;
    }

    hideContent(el){
        let $surtitle = $('.s-cap2',el),
            $title = $('h2',el),
            $lieu = $('.lieu', el),
            $button = $('.button',el)
        ;

        let tl = new TimelineLite()
        .to($surtitle,.3,{y:-30,autoAlpha:0,force3D:true,ease:Power4.easeOut},0)
        .to($title,.3,{y:-30,autoAlpha:0,force3D:true,ease:Power4.easeOut},.05)
        .to($lieu,.3,{y:-30,autoAlpha:0,force3D:true,ease:Power4.easeOut},.1)
        .to($button,.3,{y:-30,alpha:0,force3D:true,ease:Power4.easeOut},.15)
        .to(el,.3,{autoAlpha:0,display:'none',ease:Power4.easeOut})

        return tl;
    }


    changeSlide(el){
        var refThis = this;
        if(!this._isActive){
            this.current = el.index()-1;
            this.animateSlider();
            this._isUpdating = true;


        if(this.params.autoplay == true){
            this.update();
        }

        // si on click, on kill l'autoplay
        clearInterval(this.interval);
        this.stopInterval = true;
        }
        return false;
    }

    showDot(){
        let time = (this.stopInterval == true) ? 0.5 : 5;

        let $prevDot = $('.slider-dot').not(`:eq(${this.current})`).find('rect'),
            $nextDot = $('.slider-dot').eq(this.current).find('rect'),
            $cible = $('.slider-cible'),
            position = $('.slider-dot').eq(this.current).position().left,
            marginLeft = parseInt($('.slider-dot').eq(this.current).css('margin-left')),
            tl = new TimelineLite()
        ;

        tl.to($cible,.5,{x:position+marginLeft})
        tl.set($prevDot,{strokeDashoffset:200},0)
        tl.to($nextDot,time,{strokeDashoffset:400},.5)

        return tl;
    }
}

export default Slider;
